import { ROUTE_RESERVED_KEYWORDS, FILTER_TYPES } from 'operabase-router/constants';

export const getPageH1LinkProps = ({ filters = {}, part, filtersCount }) => {
  const { filterTypeKey, identifier, format } = part || {};

  if (filtersCount === 1) {
    return {};
  }

  if ([FILTER_TYPES.WHO, FILTER_TYPES.WHERE].includes(filterTypeKey) && filters[filterTypeKey]?.length === 1) {
    return {
      filters: { ...filters, [filterTypeKey]: [] },
      basePath: ROUTE_RESERVED_KEYWORDS.productions,
      tab: null,
    };
  }

  if (filterTypeKey === FILTER_TYPES.DATE) {
    const { [FILTER_TYPES.DATE]: _, ...restFilters } = filters;
    return { filters: restFilters };
  }

  if (filterTypeKey === FILTER_TYPES.GENRE && format?.id) {
    const updatedGenre = filters[FILTER_TYPES.GENRE]?.filter(item => {
      const matchesEntity = item?.entity?.id === identifier?.entityId;
      const matchesFormat = item?.format?.id === format.id;
      return !(matchesEntity && matchesFormat);
    });

    return {
      filters: {
        ...filters,
        [FILTER_TYPES.GENRE]: updatedGenre,
      },
    };
  }

  return {
    filters: {
      ...filters,
      [filterTypeKey]: filters[filterTypeKey]?.filter(item => item?.entity?.id !== identifier?.entityId),
    },
  };
};
